module.exports = __webpack_public_path__ + "static/logo_fp.9859b60c.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/logo_fp.png
// module id = 228
// module chunks = 28